import { Routes } from "@angular/router";
import * as fromContainers from './containers';

export const ROUTES: Routes = [
    {
        path: '',
        component: fromContainers.BookingComponent,
    },
    {
        path: ':booking',
        component: fromContainers.BookingComponent,
    }
];
